import { computed, defineComponent, inject, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import Cart from "../../Shared/Cart";
import CustomerDataAddress from "../CustomerDataAddress";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { useRouter } from "vue-router";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: { Cart, CustomerDataAddress },
  setup() {
    // Injections
    const { t } = useI18n();
    const router = useRouter();
    const currentOrderProvider = inject(currentOrderProviderKey);
    const orderService = inject(orderServiceKey);

    // vars und computed
    const invoiceAddress = computed(() => {
      return currentOrderProvider?.currentOrder?.value?.invoice_address ?? null;
    });
    const deliveryAddress = computed(() => {
      return currentOrderProvider?.currentOrder?.value?.delivery_address ?? null;
    });
    const technicalAddress = computed(() => {
      return currentOrderProvider?.currentOrder?.value?.technical_address ?? null;
    });

    // Checkboxen sind vorbelegt, falls bereits eine abweichende Adresse hinterlegt ist
    const showDeliveryAddress = ref(null != deliveryAddress.value);
    const showTechnicalAddress = ref(null != technicalAddress.value);

    // Wird die abweichende Adresse wieder abgewählt, muss sie auch serverseitig gelöscht
    // werden (POST mit null-Body), sonst bliebe die zuletzt gespeicherte Adresse bestehen
    watch(showDeliveryAddress, async (shown, wasShown) => {
      if (wasShown && !shown) {
        await orderService?.postAddress("delivery", null);
      }
    });
    watch(showTechnicalAddress, async (shown, wasShown) => {
      if (wasShown && !shown) {
        await orderService?.postAddress("technical", null);
      }
    });

    // template refs zu den Kind-Komponenten, um vor dem Weiterschalten deren validate()/isValid abzufragen
    const invoiceRef = ref<any>(null);
    const deliveryRef = ref<any>(null);
    const technicalRef = ref<any>(null);
    // während des Klicks auf 'next' läuft validate() ggf. noch auf einen offenen
    // Autosave-Request der Kinder; solange den Button sperren (Doppelklick-Schutz + Feedback)
    const isValidating = ref(false);

    // methods
    const next = async function(){
      const visibleChildren = [
        invoiceRef.value,
        showDeliveryAddress.value ? deliveryRef.value : null,
        showTechnicalAddress.value ? technicalRef.value : null,
      ].filter((c) => c != null);

      isValidating.value = true;
      let allValid: boolean;
      try {
        const results = await Promise.all(visibleChildren.map((c) => c.validate()));
        allValid = results.every((r) => r);
      } finally {
        isValidating.value = false;
      }
      if (!allValid) {
        return;
      }

      router.push("/completion");
    }

    const back = function(){
      router.push("/configs");
    }

    return {
      t,
      next,
      back,
      invoiceAddress,
      deliveryAddress,
      technicalAddress,
      showDeliveryAddress,
      showTechnicalAddress,
      invoiceRef,
      deliveryRef,
      technicalRef,
      isValidating,
    };
  },
} as any);
